import { createContext } from "react";
import type { FormInstance } from "antd/es/form";

export const EditableContext = createContext<FormInstance<any> | null>(null);
